<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-01-31 17:37:42
 * @FilePath: 
 * @Description: 通用的财务报表
-->
<template>
  <div class="c-p-t-1 c-p-b-30 full_page">
    <!-- </div> -->
    <ul class="business_total_data processed_info_data">
      <li
        v-for="(bItem, bIndex) in countTotalData"
        :key="bIndex"
        @click="handleViewPage(bItem.Key)"
      >
        <p ><van-icon size="26" :name="bItem.Icon" /></p>
        <p class="b_title c-m-t-10">{{ bItem.Title }}</p>
        <!-- <div class="b_count">
          {{
            turnoverObj[bItem.Key] === 0 || turnoverObj[bItem.Key]
              ? turnoverObj[bItem.Key]
              : "--"
          }}
        </div> -->
      </li>
    </ul>
    <!-- <div class="processed_data_box">
      <div class="ticheng_title_con ticheng_title_con_2">
        <p class="ticheng_left_con">待处理事件</p> -->
        <!-- <p class="c-grey-6 c-yang" @click="handleShowAll">
          全部 <i class="iconfont icon-xiangyou" style="font-size: 13px" />
        </p> -->
      <!-- </div>
      <div class="state_box_con">
        <ul class="processed_info_data">
          <li>
            <p class="b_title">待审核信息</p>
            <div class="b_count">
              {{ authInfo.authCount }}
            </div>
          </li>
          <li>
            <p class="b_title">短信预警</p>
            <div class="b_count">
              {{ authInfo.warnCount }}
            </div>
          </li>
          <li>
            <p class="b_title">短信审核</p>
            <div class="b_count">
              {{ authInfo.msgAuthCount }}
            </div>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseFinancialStatement",
  props: {},
  data() {
    return {
      turnoverObj: {
        tenantCount: 30,
        vpnCount: 60,
        equipCount: 100,
        msgCount: 3000,
      },

      countTotalData: [
        {
          Title: "商户",
          Key: "tenantCount",
          Icon:'home-o'
        },
        {
          Title: "门店",
          Key: "vpnCount",
          Icon:'shop-o'
        },
        {
          Title: "设备",
          Key: "equipCount",
          Icon:'tv-o'
        },
        // {
        //   Title: "短信余量",
        //   Key: "msgCount",
        // },
      ],
      authInfo: { authCount: 1, warnCount: 2, msgAuthCount: 5 },
    };
  },
  components: {},
  created() {},

  watch: {},

  mounted() {},
  methods: {
    handleViewPage(key) {
      let pageRouter =
        key == "tenantCount"
          ? "TenantOrderList"
          : key == "vpnCount"
          ? "VpnOrderList"
          : key == "equipCount"
          ? "EquipOrderList"
          : "";
      if (pageRouter) {
        this.$router.push({
          name: pageRouter,
        });
      }
    },
    handleShowAll() {
      // this.$router.push({
      //   name: "EquipOrderList",
      // });
    },
  },
};
</script>
<style scoped lang="scss">
.state_box_con {
  background: #ffffff;

  padding-bottom: 1px;
}
.financial_data_con {
  box-shadow: 0px 4px 10px 0px rgba(153, 151, 151, 0.3);
  margin: 32px;
  border-radius: 16px;
  overflow: hidden;
}
.ticheng_title_con {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 24px;
  margin: 0 32px;
  // background: #fff;
  font-size: 28px;
  font-weight: bold;
  color: #333;

  background: linear-gradient(90deg, #e6efff 0%, #ffffff 100%);

  .ticheng_left_con {
    // padding-left: 20px;
    position: relative;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
      vertical-align: -10px;
    }
  }
}

.processed_info_data {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 30px;
  li {
    width: 31.2%;
    box-shadow: 0px 4px 10px 0px rgba(153, 151, 151, 0.3);
    margin-right: 20px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 0;
    position: relative;
    // &::after {
    //   content: "";
    //   width: 1px;
    //   height: 88px;
    //   position: absolute;
    //   right: 0;
    //   top: 50%;
    //   margin-top: -44px;
    //   background: #d8d8d8;
    // }
    &:last-child {
      margin-right: 0;
    }

    .b_title {
      font-size: 24px;
      color: #7a7a7a;
    }
    .b_count {
      font-size: 40px;
      margin-top: 15px;
      color: #333;
      font-weight: bold;
    }
  }
}
.business_total_data {
  margin-bottom: 10px;
  li {
    width:31.2%;
  }
}
</style>
